import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatError, MatFormField, MatInputModule, MatLabel } from '@angular/material/input';
import { MatOption, MatSelect } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { FilesService } from '../../../services/files.service';
import { DialogCrearFileDirectorioSelectorComponentData } from '../dialog-crear-file-directorio-selector/dialog-crear-file-directorio-selector.component';

@Component({
  selector: 'app-dialog-crear-directorio',
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogContent,
    MatDialogTitle,
    MatDialogActions,
    MatIconModule, MatInputModule, MatError, MatFormField, MatLabel,
    ReactiveFormsModule, TranslateModule
  ],
  templateUrl: './dialog-crear-directorio.component.html',
  styleUrl: './dialog-crear-directorio.component.scss'
})
export class DialogCrearDirectorioComponent {

  directorioForm: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogCrearFileDirectorioSelectorComponentData,
    public dialogRef: MatDialogRef<DialogCrearDirectorioComponent>,
    private fb: FormBuilder,
    private service: FilesService) {
    this.directorioForm = this.fb.group({
      nombre: ['', Validators.required],
    });
  }

  onCreate(): void {
    this.service.createDirectory(`${this.data.node.path}${this.directorioForm.controls['nombre'].value}`).subscribe(node => {
      this.dialogRef.close({ node: this.data.node, addedNode: node, type: 'created' });
    });
  }

  onCancel(): void {
    this.dialogRef.close({ node: this.data.node, addedNode: undefined, type: 'cancelled' });
  }

}
